import { render } from "./EditUserView.vue?vue&type=template&id=238abc62"
import script from "./EditUserView.vue?vue&type=script&lang=js"
export * from "./EditUserView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__